import { useEffect } from 'react';
import PropTypes from 'prop-types';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import LaunchIcon from '@mui/icons-material/Launch';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import ToolTip from '@mui/material/Tooltip';
import withComponentLoader from '../../../hoc/withComponentLoader';
import IMSLink from '../Links/IMSLink';
import styles from './MenuListItem.module.scss';
import { Link } from 'react-router-dom';
import { IconButton } from '@upmc/ims.component-library';
import { determineIfExternal } from 'routes/_utils';

/**
 * Reusable component to populate the Menu
 * @returns MenuListItem component
 */
const MenuListItem = ({ item, isLoading, ...restProps }) => {
	const { setLoading } = restProps;
	const isExternalLink = determineIfExternal(item?.ArgumentPage?.trim?.());

	useEffect(() => {
		setLoading(isLoading);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [isLoading]);

	const onClickHandler = () => {
		(item?.OnClick && item.OnClick(item)) ||
			(restProps?.onClick && restProps.onClick(item));
	};

	return (
		<ListItem key={'li_' + item.ID} disablePadding onClick={onClickHandler}>
			{item?.ChildItems?.length > 0 ? (
				<>
					<ListItemButton>
						{item?.Image && (
							<ToolTip title={item.Name} placement="top-end"><ListItemIcon>{item.Image}</ListItemIcon></ToolTip>
						)}

						<ListItemText
							primary={isLoading ? 'TEMPLATE' : item.Name}
							onClick={onClickHandler}
						/>
						<IconButton component='span' onClick={onClickHandler}>
							<ChevronRightIcon fontSize='inherit' />
						</IconButton>
					</ListItemButton>
				</>
			) : item?.CustomizeFavorites ? (
				<>
					<ListItemButton>
						{item?.Image && (
							<ToolTip title={item.Name} placement="top-end"><ListItemIcon>{item.Image}</ListItemIcon></ToolTip>
						)}

						<ListItemText
							primary={isLoading ? 'TEMPLATE' : item.Name}
							className={styles.CustomizeFavoritesButton}
						/>
					</ListItemButton>
				</>
			) : item?.isReactPage ? (
				<Link to={item.ArgumentPage} className={styles.ReactLink}>
					<div className={styles.IMSLinkInnerContainer}>
						<ListItemButton>
							{item?.Image && (
								<ToolTip title={item.Name} placement="top-end"><ListItemIcon>{item.Image}</ListItemIcon></ToolTip>
							)}
							<ListItemText
								primary={isLoading ? 'TEMPLATE' : item.Name}
							/>
						</ListItemButton>
					</div>
				</Link>
			) : (
				<>
					<IMSLink
						url={item.ArgumentPage}
						rel='noopener noreferrer'
						target={item.LinkTarget ?? (isExternalLink ? '_blank' : '_self')}
						id={`IMSLink-${item.ID}`}
					>
						<div className={styles.IMSLinkInnerContainer}>
							<ListItemButton>
								{item?.Image && (
									<ToolTip title={item.Name} placement="top-end"><ListItemIcon>{item.Image}</ListItemIcon></ToolTip>
								)}
								<ListItemText
									primary={isLoading ? 'TEMPLATE' : item.Name}
								/>
								{isExternalLink && (
									<LaunchIcon fontSize='small' color='action' />
								)}
							</ListItemButton>
						</div>
					</IMSLink>
				</>
			)}
		</ListItem>
	);
};

MenuListItem.propTypes = {
	item: PropTypes.shape({
		ID: PropTypes.number.isRequired,
		Image: PropTypes.element,
		ChildItems: PropTypes.array,
	}).isRequired,
	isLoading: PropTypes.bool,
};

export default withComponentLoader(MenuListItem);
